import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { gsap } from "gsap";
import { FeatureTransitionEvents } from "./FeatureTransitionController";
import { FeaturePurpleFishEvents } from "../view/abstract/display/features/purplefish/FeaturePurpleFish";
import { GameBigWinEvents } from "../view/abstract/display/GameBigWin";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
import { GameEvent } from "./event/GameEvent";
import { SeededRandom } from "../utils/SeededRandom";
import { MainTransitionEvents } from "../view/abstract/display/GameMainTransition";
export class FeaturePurpleFishController extends AbstractGameController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeaturePurpleFishControllerEvents.BEGIN_FEATURE, this.handleBeginFeature);
    }
    async handleBeginFeature() {
        const availableBoxIndexes = Array.from({ length: 3 }, (x, i) => i);
        const seededRandomUserChoice = new SeededRandom(this.model.getGameInstanceId());
        const data = this.model.getPurpleFishChanceGameData();
        this.dispatchGame(FeaturePurpleFishEvents.FEATURE_START);
        await this.blockUntil(FeaturePurpleFishEvents.PICKS_READY);
        let index;
        if (Service.isReplay()) {
            await this.delayFor(1);
            index = this.model.consumeNextUserChoice();
            if (index === null) {
                index = seededRandomUserChoice.pickFromArray(availableBoxIndexes);
            }
        }
        else {
            index = (await this.blockUntil(FeaturePurpleFishEvents.PICK_SELECTED)).getPayload()["index"];
            this.dispatchGame(GameEvent.createUserchoiceMadeEvent({ choice: index }));
        }
        this.dispatchGame(new EventObject(FeaturePurpleFishEvents.REVEAL_PRIZES.getType(), {
            index,
            initialValue: data.getInitialPickValue(),
            missedValues: data.getInitialPickMissedValues()
        }));
        await this.blockUntil(FeaturePurpleFishEvents.REVEAL_PRIZES_COMPLETE);
        this.dispatchGame(GameBigWinEvents.PLAY);
        await this.blockUntil(GameBigWinEvents.COMPLETE);
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_BACK_TO_BASE_GAME);
        await this.blockUntil(MainTransitionEvents.BLACKOUT_MID_POINT);
        this.dispatchGame(FeaturePurpleFishEvents.CLEAR);
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    async blockUntil(event) {
        return new Promise(resolve => {
            this.registerGame(event, (recievedEvent) => {
                this.unregisterGame(event);
                resolve(recievedEvent);
            });
        });
    }
    async delayFor(timeInSeconds) {
        return new Promise(resolve => {
            gsap.delayedCall(timeInSeconds, resolve);
        });
    }
}
export class FeaturePurpleFishControllerEvents {
}
FeaturePurpleFishControllerEvents.BEGIN_FEATURE = new EventObject("FeaturePurpleFishEvents.BEGIN_FEATURE");
//# sourceMappingURL=FeaturePurpleFishController.js.map